import type { ConnectorSummary } from "../types";

export const ZABBIX_CONNECTOR_NAME = "Zabbix principal";

export interface ConnectorLinkInput {
  url: string;
  token: string;
  hostGroupIds: string[];
  mapping: Record<string, string>;
}

export interface ConnectorLinkRequest {
  path: string;
  body: Record<string, unknown>;
}

/**
 * The Zabbix connector keeps a fixed name, so a second creation collides with the unique index and
 * fails. Once the source exists, activation replaces its endpoint and token in place instead.
 */
export function connectorLinkRequest(
  existing: Pick<ConnectorSummary, "id" | "type"> | null | undefined,
  input: ConnectorLinkInput,
): ConnectorLinkRequest {
  const body = {
    type: "zabbix" as const,
    url: input.url,
    token: input.token,
    hostGroupIds: input.hostGroupIds,
    mapping: input.mapping,
    enabled: true,
  };
  return existing && existing.type === "zabbix"
    ? { path: `/api/v1/admin/connectors/${existing.id}/relink`, body }
    : { path: "/api/v1/admin/connectors", body: { name: ZABBIX_CONNECTOR_NAME, ...body } };
}
